import { topicItems } from '@/mocks/homeData';

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-500 text-white',
  accent: 'bg-accent-500 text-foreground-950',
  secondary: 'bg-secondary-500 text-white',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-10 md:mb-14">
          <div className="lg:w-1/3">
            <h2 className="text-foreground-950 font-heading font-bold text-3xl md:text-4xl leading-tight">
              热门话题
              <br />
              吃瓜风向标
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              实时追踪全网最热吃瓜话题，从网红黑料到明星八卦，从每日大赛到反差视频——这里汇聚了吃瓜群众最关心的所有热门标签。点击话题查看深度扒文，一起加入讨论。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="space-y-4 md:space-y-5">
            {topicItems.slice(0, 4).map((item, idx) => (
              <a
                key={idx}
                href="#topics"
                className="flex items-center gap-3 bg-background-800 hover:bg-background-700 rounded-xl p-4 md:p-5 transition-colors cursor-pointer"
              >
                <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0 ${tagColorMap[item.tagColor] || tagColorMap.primary}`}>
                  {item.tag}
                </span>
                <div className="min-w-0">
                  <div className="text-white font-semibold text-sm md:text-base truncate">{item.title}</div>
                  <div className="text-white/50 text-xs mt-0.5">{item.desc}</div>
                </div>
              </a>
            ))}
          </div>

          <div className="space-y-4 md:space-y-5">
            {topicItems.slice(4, 8).map((item, idx) => (
              <a
                key={idx}
                href="#topics"
                className="flex items-center gap-3 bg-background-100 hover:bg-background-200 rounded-xl p-4 md:p-5 transition-colors cursor-pointer"
              >
                <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0 ${tagColorMap[item.tagColor] || tagColorMap.primary}`}>
                  {item.tag}
                </span>
                <div className="min-w-0">
                  <div className="text-foreground-900 font-semibold text-sm md:text-base truncate">{item.title}</div>
                  <div className="text-foreground-500 text-xs mt-0.5">{item.desc}</div>
                </div>
              </a>
            ))}
          </div>

          <div className="space-y-4 md:space-y-5">
            {topicItems.slice(8, 11).map((item, idx) => (
              <a
                key={idx}
                href="#topics"
                className="flex items-center gap-3 bg-background-100 hover:bg-background-200 rounded-xl p-4 md:p-5 transition-colors cursor-pointer"
              >
                <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0 ${tagColorMap[item.tagColor] || tagColorMap.primary}`}>
                  {item.tag}
                </span>
                <div className="min-w-0">
                  <div className="text-foreground-900 font-semibold text-sm md:text-base truncate">{item.title}</div>
                  <div className="text-foreground-500 text-xs mt-0.5">{item.desc}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}